import { BAGS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const bagsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch all bags with pagination and keyword search
    getBags: builder.query({
      query: ({ keyword, pageNumber }) => ({
        url: BAGS_URL,
        params: { keyword, pageNumber },
      }),
      keepUnusedDataFor: 5,
      providesTags: ['Bags'],
    }),

    // Fetch a single bag by ID
    getBagDetails: builder.query({
      query: (bagId) => ({
        url: `${BAGS_URL}/${bagId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Create a new bag
    createBag: builder.mutation({
      query: (data) => ({
        url: BAGS_URL,
        method: 'POST',
        body: data, // Pass the bag data (e.g., date, status, details, etc.)
      }),
      invalidatesTags: ['Bags'], // Refresh bags cache
    }),

    // Update an existing bag
    updateBag: builder.mutation({
      query: (data) => ({
        url: `${BAGS_URL}/${data.bagId}`,
        method: 'PUT',
        body: data, // Includes fields like images, date, status, etc.
      }),
      invalidatesTags: ['Bags'], // Refresh bags cache
    }),

    // Upload images for bags
    uploadBagImages: builder.mutation({
      query: (data) => ({
        url: `/api/upload`, // Backend endpoint for uploading images
        method: 'POST',
        body: data, // FormData object containing multiple images
      }),
    }),

    // Delete a specific bag by ID
    deleteBag: builder.mutation({
      query: (bagId) => ({
        url: `${BAGS_URL}/${bagId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Bags'], // Refresh bags cache
    }),

    // Create a review for a specific bag
    createReview: builder.mutation({
      query: (data) => ({
        url: `${BAGS_URL}/${data.bagId}/reviews`,
        method: 'POST',
        body: data, // Includes rating and comment fields
      }),
      invalidatesTags: ['Bags'], // Refresh bags cache
    }),

    // Fetch the top-rated bags
    getTopBags: builder.query({
      query: () => `${BAGS_URL}/top`,
      keepUnusedDataFor: 5,
    }),
  }),
});

// Exporting hooks for all the endpoints
export const {
  useGetBagsQuery,
  useGetBagDetailsQuery,
  useCreateBagMutation,
  useUpdateBagMutation,
  useUploadBagImagesMutation,
  useDeleteBagMutation,
  useCreateReviewMutation,
  useGetTopBagsQuery,
} = bagsApiSlice;